import { useState, useEffect } from 'react';

export default function StickyGetStarted() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 600px (past the hero)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (dismissed) return null;

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
    >
      <div className="flex items-center gap-4 bg-slate-900 text-white px-5 py-3 rounded-full shadow-2xl border border-white/10 backdrop-blur-sm">
        {/* Pulse dot */}
        <span className="relative flex h-3 w-3 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
        </span>

        {/* Label */}
        <span className="text-sm font-medium text-gray-300 whitespace-nowrap hidden sm:block">
          Ready to master math?
        </span>

        {/* Plan buttons */}
        <a
          href="#pricing"
          className="px-5 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm font-bold rounded-full transition-all hover:scale-105 whitespace-nowrap inline-flex items-center gap-1.5 cursor-pointer"
        >
          <i className="ri-rocket-line text-base"></i>
          Get Started
        </a>

        <a
          href="#pricing"
          className="px-4 py-2 border border-white/20 hover:border-orange-400 text-white text-sm font-medium rounded-full transition-all whitespace-nowrap hidden md:inline-flex items-center gap-1.5 cursor-pointer hover:text-orange-400"
        >
          View Plans
        </a>

        {/* Dismiss */}
        <button
          onClick={() => setDismissed(true)}
          className="w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-white/10 transition-all cursor-pointer flex-shrink-0"
          aria-label="Dismiss"
        >
          <i className="ri-close-line text-base"></i>
        </button>
      </div>
    </div>
  );
}
